import { PANEL_SHAPE_GROUPS } from './panelContract'
import { PANEL_VARIANTS } from './variantMap'

// Grid-specific orientations represent the same tile family in the picker.
const ORIENTED_SHAPE_FAMILIES: Record<string, string> = {
  Hex90: 'Hex', HexSpaced: 'Hex',
  LargeDiamondHorizontal: 'LargeDiamond',
  SmallDiamondHorizontal: 'SmallDiamond', SmallDiamondSpaced: 'SmallDiamond',
  LargeTriangleRight: 'LargeTriangleTop', SmallTriangleRight: 'SmallTriangleTop',
}
const shapeFamily = (id: string) => ORIENTED_SHAPE_FAMILIES[id] || id.replace(/(?:45deg|Freeform)$/, '')

export function getAvailableGridIds(shapeIds: string[], currentPatternId: string): string[] {
  const families = new Set(shapeIds.map(shapeFamily))
  return Object.entries(PANEL_VARIANTS)
    .filter(([id, variant]) => id !== currentPatternId && PANEL_SHAPE_GROUPS[variant.name]
      .some(group => !group.unavailable && group.shapeIds.some(shapeId =>
        !group.unavailableShapeIds?.includes(shapeId) && families.has(shapeFamily(shapeId)))))
    .map(([id]) => id)
}
